import {
  type AuthProviderProps,
} from 'react-oidc-context';

/**
 * Function to get OIDC authentication configuration options
 *
 * @export
 * @param {string} [baseUrl=window.location.origin] Url used to load the application without any additional path segments
 * @param {string} [port=window.location.port] Port number used to load the application
 * @param {string} [realm='accountant'] Keycloak realm to use for authentication
 * @return {*}  {OidcClientSettings} an object containing the application's OIDC configuration
 */
export function getOidcConfig(
  baseUrl: string = window.location.origin,
  port: string = window.location.port,
  realm: string = 'accountant',
): AuthProviderProps {
  const oidcConfig = {
    authority: `${baseUrl}`,
    client_id: 'portal',
    redirect_uri: `${baseUrl}/auth/login`,
    post_logout_redirect_uri: `${baseUrl}/`,
    response_type: 'code',
    fetchRequestCredentials: 'include',
    loadUserInfo: true,
    metadataUrl: `${baseUrl}/realms/${realm}/.well-known/openid-configuration`,
    scope: 'openid',
  };
  if (baseUrl.includes('localhost') || parseInt(port) > 1024) { // Modify configuration in development and test environments
    baseUrl = `${baseUrl}`;
    const keycloakUrl = 'https://staging.platform.specia.ai';
    oidcConfig.authority = keycloakUrl;
    oidcConfig.metadataUrl = `${keycloakUrl}/realms/${realm}/.well-known/openid-configuration`;
  } else if (baseUrl.includes('dev.platform.specia.ai')) { // Modify configuration if environment variable is set
    baseUrl = `${baseUrl}`;
    const keycloakUrl = 'https://staging.platform.specia.ai';
    oidcConfig.authority = keycloakUrl;
    oidcConfig.metadataUrl = `${keycloakUrl}/realms/${realm}/.well-known/openid-configuration`;
  }
  console.debug('Oidc configuration', oidcConfig);
  return {
    checkSessionIntervalInSeconds: 15,
    automaticSilentRenew: true,
    silent_redirect_uri: `${baseUrl}/auth/renew`,
    revokeTokensOnSignout: true,
    // monitorSession: true,
    // includeIdTokenInSilentRenew: true,
    ...oidcConfig,
  };
}

export default getOidcConfig;
